export type IcStepVariants = "default" | "compact";

export type IcStepStatuses = "optional" | "required";

export type IcStepTypes = "active" | "current" | "completed" | "disabled";

export type IcStepI18n = {
  next: string;
  step: string;
  steps: string;
  of: string;
  lastStep: string;
  completed: string;
  notRequired: string;
  required: string;
  optional: string;
};
